import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import ReorderSettingsListView from 'src/sections/reorder-settings/view/reorder-settings-list-view';

// Admin-only, same as Stock Count — no seeded READ_* permission gates
// this, deliberately (see WORKFLOW_GUIDE.md).
export default function ReorderSettingsListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Reorder Settings</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <ReorderSettingsListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
